export default theme => ({
    ciro: {
        display: 'flex',
        paddingBottom: '15px'
    },
    ciroLogo: {
        marginBottom: '10px'
    },
    footer: {
        display: 'flex',
        justifyContent: 'center',
        padding: '32px 0 75px 0',
        width: '100%'
    },
    footerDivider: {
        borderColor: '#2F2F2F',
        borderWidth: '0.5px',
        fontSize: '12px',
        fontWeight: '400',
        height: '10px',
        lineHeight: '20px',
        marginLeft: '7px',
        marginRight: '7px',
        marginTop: '7px'
    },
    footerRoot: {
        flex: '1',
        justifyContent: 'flex-end',
        lineHeight: '20px'
    },
    languageButton: {
        '@media screen and (min-width: 767px)': {
            display: 'none'
        },
        boxShadow: 'none',
        margin: '10px',
        width: '150px'
    },
    link: {
        '&[disabled]': {
            cursor: 'default',
            pointerEvents: 'none'
        },
        alignSelf: 'start',
        color: '#6f6f6f',
        display: 'block',
        fontSize: '12px',
        letterSpacing: '0',
        lineHeight: '24px'
    },
    linkContainer: {
        '& > a': {
            '@media screen and (max-width: 320px)': {
                display: 'block'
            },
            paddingRight: '13px'
        },
        letterSpacing: '0',
        lineHeight: '24px',
        marginBottom: '20px'
    },
    linkContainerMobile: {
        '@media (max-width: 1200px)': {
            justifyContent: 'flex-start',
            paddingBottom: '10px'
        },
        '@media screen and (min-width: 767px)': {
            display: 'none',
        },
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        width: '-webkit-fill-available'
    },
    linkMain: {
        '&[disabled]': {
            cursor: 'default',
            pointerEvents: 'none'
        },

        '@media screen and (max-width: 767px)': {
            color: '#2F2F2F',
        },
        alignSelf: 'start',
        color: '#FFFFFF',
        display: 'block',
        fontSize: '12px',
        letterSpacing: '0',
        lineHeight: '24px',
    },
    linkMainFirst: {
        '&[disabled]': {
            cursor: 'default',
            pointerEvents: 'none'
        },

        '@media screen and (max-width: 767px)': {
            color: '#2F2F2F',
        },
        alignSelf: 'start',
        color: '#FFFFFF',
        display: 'block',
        fontSize: '12px',
        letterSpacing: '0',
        lineHeight: '24px',
    },
    text: {
        fontFamily: 'Roboto',
        fontSize: '11px',
        lineHeight: '150%'
    },
    verbiageContainer: {
        color: 'rgba(0,0,0,0.54)',
        display: 'flex',
        fontSize: '12px',
        letterSpacing: '0',
        lineHeight: '150%',
        margin: '0 auto',
        marginBottom: '30px'
    }
})
